import React, { useState, useEffect } from 'react'

import { BrManageContentButton } from '@bloomreach/react-sdk'

import Cookies from 'js-cookie'

import {
  colorMap,
  getLinkFromRef,
  getLink,
  getLinkUrl,
  getLocalPath,
  usePagination,
  getColor,
  getUrlParameter,
  compareParameters,
  alignmentMap,
  parseDataTags,
} from '../../utility'

import { fetchData } from '../../data'

import { Link2 } from '../link/link.jsx'

import './alert.css'

export const showComponentIfQueryStringMatches = (
  isPreview,
  matchQueryString,
  windowSearch
) => {
  return isPreview || matchQueryString == ''
    ? true
    : compareParameters(matchQueryString, windowSearch)
}
export function Alert({ page, component }) {
  const __HEIGHT = 74
  const searchParamId = getUrlParameter('id')
  const [items, setItems] = useState([])
  const [color, setColor] = useState()
  const [apiDocument, setApiDocument] = useState()
  const [parameters, setParameters] = useState({
    alignment: null,
    style: null,
    backgroundColor: null,
    service: null,
    subscription: null,
    showComponent: true,
    dataTags: null,
  })

  const [styles, setStyles] = useState({
    backgroundColor: null,
    textColor: null,
    secondaryColor: null,
    contentColor: null,
    buttonClass: null,
    line: null,
    alignment: null,
    dataTags: null,
  })

  const [blurb, setBlurb] = useState({
    id: null,
    document: null,
    title: null,
    subtitle: null,
    html: null,
    imageUrl: null,
    imageDescription: null,
    link: null,
  })

  const pagination = usePagination({ page, component })

  useEffect(() => {
    if (pagination && pagination.length > 0) {
      let isColor = false

      if (color) {
        const item = pagination.find((item) => color === getColor(item.keys))

        if (item) {
          setItems([])

          setBlurb(item)

          isColor = true
        }
      }

      if (!isColor) {
        setItems(pagination)

        setBlurb(pagination[0])
      }
    }
  }, [page, component, pagination])

  useEffect(() => {
    const _parameters = component.getParameters()
    const _models = component.getModels()
    const { document: _documentRef } = _models
    const _document = _documentRef && page.getContent(_documentRef)
    const showComponent = showComponentIfQueryStringMatches(
      page.isPreview(),
      _parameters.matchQueryString,
      window.location.search
    )
    setParameters({
      style: _parameters?.style,
      backgroundColor: _parameters?.backgroundColor,
      service: _parameters?.service,
      subscription: _parameters?.subscription,
      alignment: _parameters.alignment,
      showComponent,
      dataTags: parseDataTags(_parameters.dataTags),
      openModalWithQueryString: _parameters.openModalWithQueryString || '',
    })

    setStyles({
      ...colorMap[_parameters.backgroundColor || 'None'],
      ...alignmentMap[_parameters.alignment || 'Left'],
    })

    const translatedData = {}

    if (_document) {
      const data = _document?.getData() || {}
      translatedData.id = data.id
      translatedData.title = data.title
      translatedData.subtitle = data.subtitle || data.subhead
      translatedData.publicationDate = data.publicationDate
      translatedData.html =
        data.html && typeof data.html === 'object'
          ? data.html.value
          : data.html || data.content
      translatedData.imageRef = data.image || data.heroImage
      translatedData.link = data.linkCompound
    }

    const { title, subtitle, publicationDate, html, imageRef, link } =
      translatedData

    const image = imageRef && page?.getContent(imageRef)

    const imageUrl = image?.getOriginal().getUrl()
    const imageDescription = image?.getDescription()

    setBlurb({
      id: null,
      document: _document,
      title: title,
      subtitle: subtitle,
      publicationDate: publicationDate,
      html: html,
      imageUrl: imageUrl,
      imageDescription: imageDescription,
      link: getLink(getLinkFromRef(link, page), null),
    })
  }, [page, component, component?.model])

  useEffect(() => {
    const _parameters = component.getParameters()

    if (_parameters.service || _parameters.subscription) {
      return
    }

    if (!searchParamId) {
      setApiDocument(null)
    }

    if (
      searchParamId &&
      (!apiDocument || apiDocument.url.indexOf(searchParamId) < 0)
    ) {
      const documentUrl = `${getLocalPath()}/halapi/documents/${searchParamId}`

      setApiDocument({ url: documentUrl })
    }
  }, [page, component])

  useEffect(() => {
    if (apiDocument && apiDocument.url && !apiDocument.payload) {
      const fetchAsync = async () => {
        const data = await fetchData(apiDocument.url)
        if (data) {
          setApiDocument({ url: apiDocument.url, payload: data })
        }
      }

      fetchAsync()
    }
  }, [apiDocument])

  useEffect(() => {
    if (apiDocument && apiDocument.payload) {
      const data = apiDocument.payload

      const color = getColor(data['keys'])

      const item = items.find((item) => color === getColor(item.keys))

      if (item) {
        setItems([])

        setBlurb(item)

        setColor(color)
      }
    }
  }, [apiDocument])

  useEffect(() => {
    if (parameters.service === 'Relationship Manager') {
      const RM_data = {
        name: Cookies.get('CM_RM_NAME_INST'),
        email: Cookies.get('CM_RM_EML_INST'),
        phone: Cookies.get('CM_RM_PH_INST'),
      }

      setBlurb({
        ...blurb,
        html:
          RM_data.name && RM_data.email && RM_data.phone
            ? `<div>Contact your relationship manager, ${RM_data.name}: <a href='mailto:${RM_data.email}'>${RM_data.email}</a> or <a href='tel:${RM_data.phone}'>${RM_data.phone}</a></div>`
            : '',
      })
    }
  }, [page, component, parameters])

  const onClickPrevious = () => {
    const currentItem = items.indexOf(blurb)

    setBlurb(items[currentItem === 0 ? items.length - 1 : currentItem - 1])
  }

  const onClickNext = () => {
    const currentItem = items.indexOf(blurb)

    setBlurb(items[currentItem === items.length - 1 ? 0 : currentItem + 1])
  }

  return parameters.showComponent ? (
    <div
      {...parameters.dataTags}
      id={blurb.title?.replaceAll(' ', '').replaceAll("'", '')}
      className={`Alert2 u-posRelative ${
        !blurb.imageUrl || parameters.style === 'Icon'
          ? styles.line + ' ' + styles.backgroundColor
          : ''
      }`}
    >
      <BrManageContentButton content={blurb.document} />
      <div>
        {blurb.imageUrl && parameters.style !== 'Icon' && (
          <div
            className="u-posAbsolute u-sizeFull"
            style={{
              backgroundImage: 'url("' + blurb.imageUrl + '")',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              top: 0,
              left: 0,
              height: __HEIGHT,
            }}
          />
        )}
        {(blurb.title || blurb.subtitle || blurb.html) && (
          <div
            className={`u-posRelative u-sizeConstrained u-sizeFull u-flex u-flexAlignItemsCenter`}
            style={{
              top: 0,
              bottom: 0,
              zIndex: 1,
              height:
                blurb.imageUrl && parameters.style !== 'Icon'
                  ? __HEIGHT
                  : 'auto',
            }}
          >
            {items && items.length > 1 && (
              <span
                className={`u-posAbsolute Icon--material u-textSizeMsrp5 ${styles.textColor}`}
                style={{ cursor: 'pointer', left: -50, top: '15%' }}
                onClick={onClickPrevious}
              >
                navigate_before
              </span>
            )}
            <div
              className={`u-flex u-sizeFull u-paddingVert3gu ${
                parameters.alignment === 'Center' ? 'u-flexCol' : 'u-flexRow'
              }`}
            >
              <div
                className={`u-flex u-flexCol u-flexAuto u-flexJustifyCenter ${
                  styles.alignment || ''
                }`}
              >
                <div className="u-flex u-flexAlignItemsCenter">
                  {blurb.imageUrl && parameters.style === 'Icon' && (
                    <img
                      className="u-marginRight2gu"
                      style={{ maxHeight: 40 }}
                      src={blurb.imageUrl}
                      alt={blurb.imageDescription}
                    />
                  )}
                  {blurb.title && (
                    <div
                      className={`u-textSecondary u-sm-textSizeMsrp1 u-md-textSizeMsrp1 u-lg-textSizeMsrp2 ${styles.textColor}`}
                    >
                      {blurb.title}
                    </div>
                  )}
                  {blurb.subtitle && (
                    <div
                      className={`u-marginLeft2gu u-sm-textSizeMsrm1 u-md-textSizeMsrm1 ${styles.secondaryColor}`}
                    >
                      {blurb.subtitle}
                    </div>
                  )}
                  {blurb.html && (
                    <div
                      className={`Content ${styles.contentColor} ${
                        blurb.title || blurb.subtitle ? 'u-marginLeft2gu' : ''
                      }`}
                      dangerouslySetInnerHTML={{
                        __html: page.rewriteLinks(blurb.html),
                      }}
                    />
                  )}
                </div>
              </div>
              {parameters.subscription && (
                <div
                  className={`${
                    parameters.alignment === 'Center'
                      ? 'u-flex u-flexRow u-flexJustifyCenter u-marginTop2gu'
                      : ''
                  }`}
                >
                  <email-subscription-modal
                    data-use-unlabeled-button-inst="true"
                    data-subscription-name={parameters.subscription}
                    data-open-modal-with-query-string={encodeURIComponent(
                      parameters.openModalWithQueryString
                    )}
                    {...(parameters.style === 'raspberry' ||
                    parameters.backgroundColor === 'Pale Blue' ||
                    parameters.backgroundColor === 'Gray Light'
                      ? { raspberry: true }
                      : { tertiary: true })}
                  />
                </div>
              )}
              {blurb.link?.url && blurb.link?.text && (
                <div className="u-marginLeft5gu">
                  <Link2
                    url={getLinkUrl(blurb.link)}
                    text={blurb.link.text}
                    icon={blurb.link.icon}
                    iconColor={styles.secondaryColor}
                    className={`Button Button--secondary u-textUppercase u-textNoWrap u-textSizeMsrp1 u-paddingLeft4gu u-paddingRight4gu ${styles.secondaryColor} ${styles.buttonClass}`}
                  />
                </div>
              )}
            </div>
            {items && items.length > 1 && (
              <span
                className={`u-posAbsolute Icon--material u-textSizeMsrp5 ${styles.textColor}`}
                style={{ cursor: 'pointer', right: -50, top: '20%' }}
                onClick={onClickNext}
              >
                navigate_next
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  ) : null
}
